import { Theme } from '@eversports/react-components/design-tokens/theme'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
  page: {
    maxWidth: 1400,
    padding: theme.spacing(2),
  },
}))

const Page: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const classes = useStyles()

  return (
    <Flex
      flexDirection="column"
      marginRight="auto"
      marginLeft="auto"
      marginTop="none"
      marginBottom="none"
      className={classes.page}
      fullWidth
    >
      {children}
    </Flex>
  )
}

export default Page
